import $ from 'jquery';
import _, { filter } from 'lodash';
import barycentric from 'barycentric';
import React from "react";
import { createRoot } from "react-dom/client";
import { StyleSlider } from "../components/StyleSlider";

const updateFilteredItemsData = (thisItem) => {
    let filteredItems = $(".programm-header").data("filtered-items")
    ? $(".programm-header").data("filtered-items")
    : [];
    if (thisItem.startsWith("style-")) {
        let styleType = thisItem.split("-")[1];
        if (styleType == "modern") {
            filteredItems = _.filter(
                filteredItems,
                (item) => !item.startsWith("style-modern")
            );
        }
        if (styleType == "avant") {
            filteredItems = _.filter(
                filteredItems,
                (item) => !item.startsWith("style-avant")
            );
        }
        if (styleType == "electric") {
            filteredItems = _.filter(
                filteredItems,
                (item) => !item.startsWith("style-electric")
            );
        }
    }

    if (_.indexOf(filteredItems, thisItem) == -1) {
        filteredItems = _.union(filteredItems, [thisItem]);
    } else {
        let index = filteredItems.indexOf(thisItem);
        if (index > -1) {
            filteredItems.splice(index, 1);
        }
    }
    $(".programm-header").data("filtered-items", filteredItems);
    //console.log('now filtered for:' + filteredItems);
    return filteredItems;
}

const updateFilteredElements = (filteredItems) => {
    let activeFilters = filteredItems;
    //console.log(activeFilters);
    let allItems = document.querySelectorAll(".filter-item");
    let allItemsWithProps = [];
    for (let item of allItems) {
        const itemClasses = item.classList.entries();
        let styleValues = {
            modern: 0,
            avant: 0,
            electric: 0,
        };
        for (let itemClass of itemClasses) {
            //console.log(itemClass);
            if (itemClass[1].startsWith("filter-style-modern-")) {
                styleValues.modern = parseInt(itemClass[1].split("-")[3]);
            }
            if (itemClass[1].startsWith("filter-style-avant-")) {
                styleValues.avant = parseInt(itemClass[1].split("-")[3]);
            }
            if (itemClass[1].startsWith("filter-style-electric-")) {
                styleValues.electric = parseInt(itemClass[1].split("-")[3]);
            }
        }
        allItemsWithProps.push({
            item: item,
            classes: item.classList,
            styleValues,
        });
    }
    //console.log(allItemsWithProps);
    if (activeFilters.length == 0) {
        $(".filter-item").show();
    } else {
        let filterLocations = [];
        let filterDates = [];
        let filterTypes = [];
        let filterStyles = [];
        let filterStyleValues = {};
        let filterMatrix = [];

        for (let filterItem of activeFilters) {
            if (filterItem.startsWith("location")) {
                filterLocations.push("filter-" + filterItem);
            }
            if (filterItem.startsWith("date")) {
                filterDates.push("filter-" + filterItem);
            }
            if (filterItem.startsWith("type")) {
                filterTypes.push("filter-" + filterItem);
            }
            if (filterItem.startsWith("style")) {
                filterStyles.push("filter-" + filterItem);
            }
        }
        filterMatrix = [
            filterLocations,
            filterDates,
            filterTypes,
            //filterStyles
        ];

        //console.log(filterStyles);

        let styleModernThreshold = filterStyles.filter((item) =>
            item.startsWith("filter-style-modern-")
        );
        styleModernThreshold = styleModernThreshold.length
            ? parseInt(styleModernThreshold[0].split("-")[3])
            : 0;
        let styleAvantThreshold = filterStyles.filter((item) =>
            item.startsWith("filter-style-avant-")
        );
        styleAvantThreshold = styleAvantThreshold.length
            ? parseInt(styleAvantThreshold[0].split("-")[3])
            : 0;
        let styleElectricThreshold = filterStyles.filter((item) =>
            item.startsWith("filter-style-electric-")
        );
        styleElectricThreshold = styleElectricThreshold.length
            ? parseInt(styleElectricThreshold[0].split("-")[3])
            : 0;
        filterStyleValues = {
            avant: styleAvantThreshold,
            modern: styleModernThreshold,
            electric: styleElectricThreshold,
        };
        //console.log(filterMatrix);
        //console.log(filterStyleValues);
        $(".filter-item").hide();
        for (let item of allItemsWithProps) {
            if (isVisible(item, filterMatrix, filterStyleValues)) {
                $(item.item).show();
                continue;
            }
        }
    }

    //update first child
    $(".programm-main > div.programm-item").removeClass("first-child");

    $(".programm-main > div.programm-item-separator:visible").each(
        function () {
            $(this).nextAll(":visible").first().addClass("first-child");
        }
    );
}


const isVisible = (item, activeFilterMatrix, filterStyleValues) => {
    let isVisible = true;
    let isAnyFilterActive = false;

        for (let activeFilters of activeFilterMatrix) {
            let thisFilterIsVisible = true;
            if (activeFilters.length != 0) {
                isAnyFilterActive = true;
                thisFilterIsVisible = false;
                for (let activeFilter of activeFilters) {
                    if (item.classes.contains(activeFilter)) {
                        thisFilterIsVisible = true;
                    }
                }
            }
            isVisible = isVisible && thisFilterIsVisible;
        }
        if (isVisible) {
            //let's check the styles
            const filterDelta = 20;
            const styleModernAdj =
                filterStyleValues.modern; // - Math.pow(filterStyleValues.modern, 2 / 3);
            const styleAvantAdj =
                filterStyleValues.avant; // - Math.pow(filterStyleValues.avant, 2 / 3);
            const styleElectricAdj =
                filterStyleValues.electric; // - Math.pow(filterStyleValues.electric, 2 / 3);

            if (
                item.styleValues.modern >= styleModernAdj &&
                item.styleValues.avant >= styleAvantAdj &&
                item.styleValues.electric >= styleElectricAdj
            ) {
                isVisible = true;
            } else {
                isVisible = false;
            }
        }
    return isVisible;
}

export default {
    onMenuSelectClick(e, filterType) {
        //console.log('onMenuSelectClick', filterType);
        if (
            filterType + "-active" == "style-active" &&
            $(".programm-header").hasClass("style-active")
        ) {
            this.removeStyleFilters();
            $(".programm-header").toggleClass(filterType + "-active");
        } else {
            $(".programm-header").toggleClass(filterType + "-active");
        }
    },

    removeStyleFilters() {
        //console.log('remove filters');
        //remove all style filters
        let filteredItems = $(".programm-header").data("filtered-items");
        //console.log('filteredItems', filteredItems);
        if (filteredItems) {
            filteredItems = _.filter(
                filteredItems,
                (item) => !item.startsWith("style-")
            );
            $(".programm-header").data("filtered-items", filteredItems);
            //console.log('now filtered for:' + filteredItems);
        }
        if (filteredItems) {
            this.updateFilteredElements(filteredItems);
        }
        //console.log("now filtered for:" + $(".programm-header").data("filtered-items"));
    },

    updateFilteredItemsData(thisItem) {
        let filteredItems = $(".programm-header").data("filtered-items")
            ? $(".programm-header").data("filtered-items")
            : [];
        if (thisItem.startsWith("style-")) {
            let styleType = thisItem.split("-")[1];
            if (styleType == "modern") {
                filteredItems = _.filter(
                    filteredItems,
                    (item) => !item.startsWith("style-modern")
                );
            }
            if (styleType == "avant") {
                filteredItems = _.filter(
                    filteredItems,
                    (item) => !item.startsWith("style-avant")
                );
            }
            if (styleType == "electric") {
                filteredItems = _.filter(
                    filteredItems,
                    (item) => !item.startsWith("style-electric")
                );
            }
        }

        if (_.indexOf(filteredItems, thisItem) == -1) {
            filteredItems = _.union(filteredItems, [thisItem]);
        } else {
            let index = filteredItems.indexOf(thisItem);
            if (index > -1) {
                filteredItems.splice(index, 1);
            }
        }
        $(".programm-header").data("filtered-items", filteredItems);
        //console.log('now filtered for:' + filteredItems);
        return filteredItems;
    },

    updateCheckboxes(filteredItems) {
        $(".programm-dropdown li, .programm-free, .programm-favorited").removeClass("selected");
        $(".programm-dropdown li, .programm-free, .programm-favorited")
            .filter(function () {
                return _.indexOf(filteredItems, $(this).data("filter")) != -1;
            })
            .addClass("selected");
    },

    isVisible(item, activeFilterMatrix, filterStyleValues) {
        let isVisible = true;
        let isAnyFilterActive = false;

        for (let activeFilters of activeFilterMatrix) {
            let thisFilterIsVisible = true;
            if (activeFilters.length != 0) {
                isAnyFilterActive = true;
                thisFilterIsVisible = false;
                for (let activeFilter of activeFilters) {
                    if (item.classes.contains(activeFilter)) {
                        thisFilterIsVisible = true;
                    }
                }
            }
            isVisible = isVisible && thisFilterIsVisible;
        }
        if (isVisible) {
            //let's check the styles
            const filterDelta = 20;
            const styleModernAdj =
                filterStyleValues.modern; // - Math.pow(filterStyleValues.modern, 2 / 3);
            const styleAvantAdj =
                filterStyleValues.avant; // - Math.pow(filterStyleValues.avant, 2 / 3);
            const styleElectricAdj =
                filterStyleValues.electric; // - Math.pow(filterStyleValues.electric, 2 / 3);

            if (
                item.styleValues.modern >= styleModernAdj &&
                item.styleValues.avant >= styleAvantAdj &&
                item.styleValues.electric >= styleElectricAdj
            ) {
                isVisible = true;
            } else {
                isVisible = false;
            }
        }
        return isVisible;
    },

    updateFilteredElements(filteredItems) {
        let activeFilters = filteredItems;
        console.log(activeFilters);
        let allItems = document.querySelectorAll(".filter-item");
        let allItemsWithProps = [];
        for (let item of allItems) {
            const itemClasses = item.classList.entries();
            let styleValues = {
                modern: 0,
                avant: 0,
                electric: 0,
            };
            for (let itemClass of itemClasses) {
                //console.log(itemClass);
                if (itemClass[1].startsWith("filter-style-modern-")) {
                    styleValues.modern = parseInt(itemClass[1].split("-")[3]);
                }
                if (itemClass[1].startsWith("filter-style-avant-")) {
                    styleValues.avant = parseInt(itemClass[1].split("-")[3]);
                }
                if (itemClass[1].startsWith("filter-style-electric-")) {
                    styleValues.electric = parseInt(itemClass[1].split("-")[3]);
                }
            }
            allItemsWithProps.push({
                item: item,
                classes: item.classList,
                styleValues,
            });
        }
        //console.log(allItemsWithProps);
        if (activeFilters.length == 0) {
            $(".filter-item").show();
        } else {
            let filterLocations = [];
            let filterDates = [];
            let filterTypes = [];
            let filterStyles = [];
            let filterStyleValues = {};
            let filterMatrix = [];

            for (let filterItem of activeFilters) {
                if (filterItem.startsWith("location")) {
                    filterLocations.push("filter-" + filterItem);
                }
                if (filterItem.startsWith("date")) {
                    filterDates.push("filter-" + filterItem);
                }
                if (filterItem.startsWith("type")) {
                    filterTypes.push("filter-" + filterItem);
                }
                if (filterItem.startsWith("style")) {
                    filterStyles.push("filter-" + filterItem);
                }
            }
            filterMatrix = [
                filterLocations,
                filterDates,
                filterTypes,
                //filterStyles
            ];

            //console.log(filterStyles);

            let styleModernThreshold = filterStyles.filter((item) =>
                item.startsWith("filter-style-modern-")
            );
            styleModernThreshold = styleModernThreshold.length
                ? parseInt(styleModernThreshold[0].split("-")[3])
                : 0;
            let styleAvantThreshold = filterStyles.filter((item) =>
                item.startsWith("filter-style-avant-")
            );
            styleAvantThreshold = styleAvantThreshold.length
                ? parseInt(styleAvantThreshold[0].split("-")[3])
                : 0;
            let styleElectricThreshold = filterStyles.filter((item) =>
                item.startsWith("filter-style-electric-")
            );
            styleElectricThreshold = styleElectricThreshold.length
                ? parseInt(styleElectricThreshold[0].split("-")[3])
                : 0;
            filterStyleValues = {
                avant: styleAvantThreshold,
                modern: styleModernThreshold,
                electric: styleElectricThreshold,
            };
            //console.log(filterMatrix);
            //console.log(filterStyleValues);
            $(".filter-item").hide();
            for (let item of allItemsWithProps) {
                if (this.isVisible(item, filterMatrix, filterStyleValues)) {
                    $(item.item).show();
                    continue;
                }
            }
        }

        //update first child
        $(".programm-main > div.programm-item").removeClass("first-child");

        $(".programm-main > div.programm-item-separator:visible").each(
            function () {
                $(this).nextAll(":visible").first().addClass("first-child");
            }
        );
    },

    onClickCheckbox(thisItem) {
        let filteredItems = this.updateFilteredItemsData(thisItem);
        this.updateCheckboxes(filteredItems);
        this.updateFilteredElements(filteredItems);
    },

    getPositionAndValues(elem, position) {
        //console.log("***********************");
        var pinContainer = $(".style-triangle-pin-container");
        var containerWidth = pinContainer.width();
        var containerHeight = pinContainer.height();
        var elementWidth = $(elem).width();
        var elementHeight = $(elem).height();

        var x = position.left + elementWidth / 2;
        var y = position.top + elementHeight / 2;
        var elteres = Math.abs(x - containerWidth / 2);
        var min_y = containerHeight * (elteres / (containerWidth / 2)) + 10;
        if (y < min_y) {
            y = min_y;
        }
        if (x < 12) {
            x = 12;
        }
        if (y < 14) {
            y = 14;
        }
        if (x > containerWidth - 16) {
            x = containerWidth - 16;
        }
        if (y > containerHeight - 16) {
            y = containerHeight - 16;
        }

        position.top = y - elementHeight / 2;
        position.left = x - elementWidth / 2;

        let barys = barycentric(
            [
                [10, 147.5],
                [168, 147.5],
                [91, 9.5],
            ],
            [x, y]
        );
        let barysSum = barys[0] + barys[1] + barys[2];
        let barysModern = parseInt((barys[2] / barysSum) * 100);
        let barysElectric = parseInt((barys[0] / barysSum) * 100);
        let barysAvant = parseInt((barys[1] / barysSum) * 100);

        var _relativePerc = function (input, min, max) {
            return ((input - min) * 100) / (max - min);
        };
        const threshhold = 33;
        if (barysAvant < threshhold) {
            barysAvant = threshhold;
        }
        if (barysModern < threshhold) {
            barysModern = threshhold;
        }
        if (barysElectric < threshhold) {
            barysElectric = threshhold;
        }

        barysAvant = _relativePerc(barysAvant, threshhold, 100);
        barysModern = _relativePerc(barysModern, threshhold, 100);
        barysElectric = _relativePerc(barysElectric, threshhold, 100);

        return {
            position: position,
            corners: [barysModern, barysElectric, barysAvant],
        };
    },

    updateCorners(corners) {
        $("#style-bar-handle-modern").css(
            "left",
            "calc(" + corners[0] + "% - 13px)"
        );
        $("#style-bar-handle-avant").css(
            "left",
            "calc(" + corners[2] + "% - 13px)"
        );
        $("#style-bar-handle-electric").css(
            "left",
            "calc(" + corners[1] + "% - 13px)"
        );
    },

    /*onClickTriangle(e) {
        let pinContainer = $(".style-triangle-pin-container").offset();
        let newPosition = {
            top: e.pageY - pinContainer.top - 10,
            left: e.pageX - pinContainer.left - 10,
        };
        //console.log(newPosition);
        let pin = $(".style-triangle-pin");
        let clickResult = this.getPositionAndValues(pin, newPosition);
        pin.css(clickResult.position);
        this.updateCorners(clickResult.corners);
        let filteredItems = this.updateFilteredItemsData(
            "style-avant-" + parseInt(clickResult.corners[2])
        );
        filteredItems = this.updateFilteredItemsData(
            "style-modern-" + parseInt(clickResult.corners[0])
        );
        filteredItems = this.updateFilteredItemsData(
            "style-electric-" + parseInt(clickResult.corners[1])
        );
        this.updateFilteredElements(filteredItems);
    },*/

    onChangeModernSlider(value) {
        //console.log("onChangeModernSlider", value);
        let filteredItems = updateFilteredItemsData(
            "style-modern-" + parseInt(value)
        );
        updateFilteredElements(filteredItems);
    },

    onChangeAvantSlider(value) {
        //console.log("onChangeAvantSlider", value);
        let filteredItems = updateFilteredItemsData(
            "style-avant-" + parseInt(value)
        );
        updateFilteredElements(filteredItems);
    },

    onChangeElectricSlider(value) {
        //console.log("onChangeElectricSlider", value);
        let filteredItems = updateFilteredItemsData(
            "style-electric-" + parseInt(value)
        );
        updateFilteredElements(filteredItems);
    },

    init() {
        /*$("#triangle").triangle({
        colors: true,
        callback: function (values) {
            setSliders("triangleSliders", values);
        },
    });*/
        const modernRoot = createRoot(document.getElementById("modern-slider"));
        modernRoot.render(<StyleSlider onChange={this.onChangeModernSlider} />);
        const avantRoot = createRoot(document.getElementById("avant-slider"));
        avantRoot.render(<StyleSlider onChange={this.onChangeAvantSlider} />);
        const electricRoot = createRoot(document.getElementById("electric-slider"));
        electricRoot.render(<StyleSlider onChange={this.onChangeElectricSlider} />);
    },

    finalize() {
        $(".programm-dropdown > li, .programm-free, .programm-favorited").on("click", (event) =>
            this.onClickCheckbox($(event.currentTarget).data("filter"))
        );

        $(".menu-select").on("click", (event) =>
            this.onMenuSelectClick(event, $(event.currentTarget).data("type"))
        );

        /*$(".style-triangle-pin-container").click((e) =>
            this.onClickTriangle(e)
        );*/

        this.scrollToUpcoming();
    },

    scrollToUpcoming() {
        const firstUpcoming = document.querySelector(
            ".programm-item.filter-item:not(.filter-past-is-past)"
        );
        if (!firstUpcoming) {
            return;
        }
        const previous = firstUpcoming.previousElementSibling;
        const target =
            previous && previous.classList.contains("programm-item-separator")
                ? previous
                : firstUpcoming;
        const targetTop = target.getBoundingClientRect().top + window.pageYOffset;
        window.scrollTo({ top: targetTop, behavior: "auto" });
    },
};
